export const displayName = (
  account: { id: string; displayName?: string | null },
  restaurants?: { stripeAccountId?: string | null; name?: string | null }[],
  fallback?: string,
) =>
  account.displayName ??
  restaurants?.find((r) => account.id === r.stripeAccountId)?.name ??
  fallback;
